<div class="dialog-wrapper">
  <h1 mat-dialog-title class="title">Update Available</h1>
  @if (appVersion$ | async; as data) {
    <h2 class="sub-title">
      Version {{ data.version }}
      <span style="font-size: 20px">({{ data.releaseDate }})</span>
    </h2>
    <mat-dialog-content>
      @if (data.description.bugFixes.length > 0) {
        <div class="bug-fix-title">Bug Fix</div>
        <ul>
          @for (bug of data.description.bugFixes; track bug) {
            <li class="content">
              {{ bug }}
            </li>
          }
        </ul>
      }
      @if (data.description.newFeatures.length > 0) {
        <div class="new-features-title">New</div>
        <ul>
          @for (feature of data.description.newFeatures; track feature) {
            <li class="content">
              {{ feature }}
            </li>
          }
        </ul>
      }
    </mat-dialog-content>
  } @else {
    <div class="loading">
      <mat-progress-spinner mode="indeterminate" [diameter]="100"></mat-progress-spinner>
    </div>
  }

  <div class="actions" mat-dialog-actions align="center">
    <button mat-stroked-button mat-dialog-close class="no-btn">Not Now</button>
    <button mat-flat-button [mat-dialog-close]="true" class="yes-btn">Update</button>
  </div>
</div>
